module.exports = __webpack_public_path__ + "img/dzbh-text.3148872.png";